import { render, staticRenderFns } from "./TiktokAsidePopup.vue?vue&type=template&id=d2e3ba60&scoped=true&"
import script from "./TiktokAsidePopup.vue?vue&type=script&lang=js&"
export * from "./TiktokAsidePopup.vue?vue&type=script&lang=js&"
import style0 from "./TiktokAsidePopup.vue?vue&type=style&index=0&id=d2e3ba60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e3ba60",
  null
  
)

component.options.__file = "TiktokAsidePopup.vue"
export default component.exports